import SmartButtonIcon from "@mui/icons-material/SmartButton";
import {
  Box,
  Checkbox,
  FormControlLabel,
  IconButton,
  Stack,
  Typography,
} from "@mui/material";
import {
  ApiErrorHandler,
  OrganizationContext,
  useTranslation,
} from "hhn-commons";
import { useContext, useState } from "react";
import { ConfirmationDialog } from "../../../../common/ConfirmationDialog";
import { EXPORT_TYPE, IExportChatFields } from "@home-health-notify/domain";
import { useSnackbar } from "notistack";
import { ErrorMessage } from "../../../../utils/ErrorMessage";
import { RightDrawerContext } from "../../../../context/RightDrawerContext";
import AddPatientGroup from "../../../../addPatientGroup/AddPatientGroup";

export const NewEpisode = ({ chatId }: { chatId: string }) => {
  const { t } = useTranslation();
  const tNs = (key: string) => t(key, { ns: "groupChatInfo" });
  const tNs2 = (key: string) => t(key, { ns: "exportChat" });
  const { selectedOrgUser } = useContext(OrganizationContext);
  const { enqueueSnackbar } = useSnackbar();

  const [isConfirmationDialogOpen, setConfirmationDialogOpen] = useState(false);
  const [hasAgreed, setHasAgreed] = useState(false);
  const { openDrawer, setContent } = useContext(RightDrawerContext);
  const openNewPatientGroup = () => {
    setContent(<AddPatientGroup mode="episode" chatId={chatId} />);
    openDrawer();
  };
  const downloadExport = async (
    id: string,
    type: EXPORT_TYPE,
    errorMessage: string,
  ) => {
    try {
      const exportChatData: IExportChatFields = {
        chatId: id,
        exportType: type,
      };

      await selectedOrgUser?.exportChat.initiateExport(exportChatData, false);
    } catch (e) {
      ApiErrorHandler(e, enqueueSnackbar, errorMessage);
    }
  };
  const onConfirmationAction = async () => {
    try {
      await Promise.all([
        downloadExport(
          chatId,
          EXPORT_TYPE.CHAT,
          ErrorMessage.DOWNLOAD_EXPORT_CHAT,
        ),
        downloadExport(
          chatId,
          EXPORT_TYPE.MEDIA,
          ErrorMessage.DOWNLOAD_MEDIA_CHAT,
        ),
      ]);
      enqueueSnackbar(tNs2("success"), { variant: "success" });
      openNewPatientGroup();
      setConfirmationDialogOpen(false);
      setHasAgreed(false);
    } catch (e) {
      ApiErrorHandler(e, enqueueSnackbar);
    }
  };

  return (
    <Box sx={{ padding: "20px", display: "flex", alignItems: "center" }}>
      <IconButton onClick={() => setConfirmationDialogOpen(true)}>
        <SmartButtonIcon sx={{ fontSize: "30px", marginRight: "10px" }} />
        <Typography color="secondary">{tNs("newEpisode")}</Typography>
      </IconButton>

      <ConfirmationDialog
        isOpen={isConfirmationDialogOpen}
        onClose={() => setConfirmationDialogOpen(false)}
        confirmationMessage={tNs("newEpisodeConfirmationMsg")}
        confirmationTitle={tNs("newEpisodeConfirmationTitle")}
        confirmationButtonText={tNs("newEpisodeContinue")}
        confirmationCancelText={tNs("cancel")}
        onConfirmationAction={() => onConfirmationAction()}
        disableConfirm={!hasAgreed}
      >
        <Stack spacing={2}>
          <Typography color="error" variant="body2" sx={{
            fontWeight: "bold"
          }}>
            {tNs("newEpisodeWarning")}
          </Typography>
          <FormControlLabel
            control={
              <Checkbox
                checked={hasAgreed}
                onChange={(_, checked) => setHasAgreed(checked)}
              />
            }
            label={tNs("iHaveReadAndAgree")}
          />
        </Stack>
      </ConfirmationDialog>
    </Box>
  );
};
